export const IMPORT_RESULT_STATUS = {
    NONE: '',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    STOPPED: 'stopped'
};
